/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateHookActionResult
 */
export interface ValidateHookActionResult {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateHookActionResult
     */
    valid?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidateHookActionResult
     */
    errors?: Array<string>;
}

/**
 * Check if a given object implements the ValidateHookActionResult interface.
 */
export function instanceOfValidateHookActionResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ValidateHookActionResultFromJSON(json: any): ValidateHookActionResult {
    return ValidateHookActionResultFromJSONTyped(json, false);
}

export function ValidateHookActionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateHookActionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valid': !exists(json, 'valid') ? undefined : json['valid'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}

export function ValidateHookActionResultToJSON(value?: ValidateHookActionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valid': value.valid,
        'errors': value.errors,
    };
}

